// Marketing section shell (redesign, MARKETING_REBUILD_HANDOFF.md).
// White left sidebar with Run / Measure / Tools nav groups + a per-route
// top bar. Replaces the old 8-tab horizontal nav. Screens render into
// the Outlet; cross-screen data (budget summary, AC, GSC, GA4) loads
// once in MarketingProvider.

import { Outlet } from 'react-router-dom';
import { MarketingProvider } from './MarketingContext';
import MarketingSidebar from './shell/MarketingSidebar';
import MarketingTopBar from './shell/MarketingTopBar';

export default function MarketingSection() {
  return (
    <MarketingProvider>
      <div className="flex gap-5 items-start">
        <MarketingSidebar />
        <div className="flex-1 min-w-0 max-w-[1240px]">
          <MarketingTopBar />
          <Outlet />
        </div>
      </div>
    </MarketingProvider>
  );
}
